import service from "./service";

function kmcTrCert(randomStr, type) {
  try {
    const res = service.kmcTrCert(randomStr, type);
    return res;
  } catch (error) {
    console.log(error);
  }
}

export default {
  kmcTrCert,
};
